import { getForwardedEnvQuery } from './forwardedEnvQuery';

export type ProductUpdatesSlugResolution =
  | { status: 'exists'; publishedDate?: string }
  | { status: 'missing' }
  | { status: 'error' };

export async function fetchProductUpdatesSlugResolution(
  slug: string,
  locale: string,
): Promise<ProductUpdatesSlugResolution> {
  try {
    const res = await fetch(
      `/mlp-cms/api/product-updates/resolve-slug?locale=${encodeURIComponent(locale)}&slug=${encodeURIComponent(slug)}${getForwardedEnvQuery()}`,
    );

    if (!res.ok) {
      return { status: 'error' };
    }

    const data = await res.json();
    if (data.exists) {
      return {
        status: 'exists',
        ...(data.publishedDate && { publishedDate: data.publishedDate }),
      };
    }
    return { status: 'missing' };
  } catch {
    return { status: 'error' };
  }
}
